var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 471,
    viewBox: "0 0 455 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -8.99988,
    y: 77.7795,
    width: 390.281,
    height: 411.963,
    rx: 46,
    transform: "rotate(-12.8472 -8.99988 77.7795)",
    fill: "url(#paint0_linear_0_1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0605,
    y: 90.3892,
    width: 357.757,
    height: 309.465,
    rx: 32,
    transform: "rotate(-12.8472 11.0605 90.3892)",
    fill: "url(#paint1_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.148 98.3059C236.148 98.3059 234.624 93.6126 233.85 90.5436C233.077 87.4747 233.481 80.0625 239.747 74.7068C246.014 69.3511 252.439 67.7664 260.593 71.1117C268.747 74.4569 269.813 81.4563 270.367 85.7964C270.921 90.1365 270.412 92.1689 270.412 92.1689C270.412 92.1689 271.355 89.5466 272.61 90.3613C273.866 91.176 273.905 92.1264 273.905 92.1264C273.905 92.1264 277.532 92.3105 278.624 94.7604C279.716 97.2103 277.761 99.6047 277.761 99.6047C277.761 99.6047 282.782 100.146 288.127 103.424C293.472 106.702 301.382 116.2 305.202 120.455C309.023 124.71 309.697 125.91 309.697 125.91C309.697 125.91 316.658 132.628 317.978 143.507C319.298 154.386 309.753 154.445 309.753 154.445C309.753 154.445 312.421 162.293 313.768 164.191C315.115 166.089 326.745 183.238 327.992 186.856C329.239 190.474 331.678 190.517 332.493 196.244C333.308 201.97 329.486 218.573 300.276 229.947C271.066 241.32 250.048 237.876 248.625 233.458C247.203 229.041 235.7 165.389 235.7 165.389C235.7 165.389 232.868 164.453 233.511 165.867C234.154 167.28 234.341 169.645 231.92 172.024C229.5 174.403 227.328 177.147 223.591 179.658C219.854 182.169 220.651 179.863 216.416 181.983C212.181 184.103 209.727 180.398 206.577 180.034C203.427 179.67 196.039 176.639 196.039 176.639C196.039 176.639 184.327 171.712 181.057 168.833C177.788 165.954 176.651 164.331 176.651 164.331C176.651 164.331 172.873 164.216 171.329 164.265C169.785 164.313 169.815 164.416 168.962 164.547C168.109 164.677 165.267 163.481 165.267 163.481C165.267 163.481 163.928 164.25 162.533 163.645C161.137 163.039 160.294 161.833 160.294 161.833C160.294 161.833 157.854 162.968 155.911 161.753C153.968 160.538 154.556 155.787 154.556 155.787C154.556 155.787 146.737 157.878 143.915 157.417C141.093 156.956 139.415 156.675 136.853 153.869C134.291 151.063 134.18 150.673 134.18 150.673L55.6 174.433C54.7667 174.669 53.4033 172.435 52.5547 169.443C51.7061 166.451 51.6936 163.834 52.5269 163.598L65.0525 160.391L74.8693 162.98L158.786 137.379C158.786 137.379 158.809 136.865 160.666 136.253C162.523 135.642 199.592 123.775 199.592 123.775L207.445 121.041L207.037 119.529L207.293 118.735L209.232 118.113C209.232 118.113 209.792 116.271 210.12 115.817C210.448 115.363 210.138 114.946 210.138 114.946C210.138 114.946 208.854 114.83 207.503 116.848C206.152 118.866 200.666 120.638 197.109 121.575C193.551 122.512 191.012 118.904 190.153 116.55C189.293 114.197 189.549 109.267 192.7 108.436C195.852 107.605 201.866 105.586 204.506 106.489C207.146 107.392 206.526 107.861 208.069 107.402C209.612 106.944 210.722 106.064 211.72 105.969C212.717 105.875 213.557 106.18 214.096 105.944C214.635 105.707 213.566 102.748 213.566 102.748C213.566 102.748 212.213 100.999 213.562 100.449C214.912 99.8992 219.568 98.4741 220.197 98.923C220.826 99.3719 221.039 100.713 220.685 100.938C220.331 101.164 221.345 103.93 221.345 103.93L225.899 102.805C225.899 102.805 226.369 100.999 228.222 100.306C230.075 99.6138 236.148 98.3059 236.148 98.3059ZM222.715 139.208L192.35 146.593L191.3 152.028C191.3 152.028 198.621 152.997 200.326 153.878C202.03 154.758 202.528 155.071 203.333 155.343C204.137 155.615 207.774 157.539 207.774 157.539C207.774 157.539 209.476 156.647 210.427 156.15C211.377 155.653 214.867 152.891 215.097 151.78C215.328 150.669 214.746 146.696 218.134 144.054C221.522 141.411 222.715 139.208 222.715 139.208Z",
    fill: "url(#paint2_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 182.865,
    y1: 32.5286,
    x2: 186.14,
    y2: 489.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 189.939,
    y1: 90.3892,
    x2: 197.541,
    y2: 470.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91995F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FBD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 251.55,
    y1: 74.05,
    x2: 251.55,
    y2: 380.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#445136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A785"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryLeft);
export default __webpack_public_path__ + "static/media/gallery_left.c739485ba838819fa8c1d0b47f60f22a.svg";
export { ForwardRef as ReactComponent };